import { 
  statusExpenseStart,
  statusExpenseSuccess,
  statusExpenseFailure 
} from "./expenseSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getExpensesApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusExpenseStart())
    const response = await get(`expense`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusExpenseSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusExpenseFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusExpenseFailure(errData))
      return [errData]
    }
  }
}

export const AddExpenseApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusExpenseStart())
    const response = await post(`expense`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusExpenseSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusExpenseFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusExpenseFailure(errData))
      return [errData]
    }
  }
}

export const EditExpenseApi = (expenseId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusExpenseStart())
    const response = await put(`expense/${expenseId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusExpenseSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusExpenseFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusExpenseFailure(errData))
      return [errData]
    }
  }
}

export const DeleteExpenseApi = (expenseId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusExpenseStart())
    const response = await remove(`expense/${expenseId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusExpenseSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusExpenseFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusExpenseFailure(errData))
      return [errData]
    }
  }
}


export const clearExpenseApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusExpenseSuccess([]))
}
